export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Viernes_eng.5622170a.png";